import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Active Passes</Typography>
      <p>This table lists all the templates which have currently active passes along with a counter</p>
      <p>Click a template to view the individual passes issued for that template.</p>
    </div>
  )
}

export default HelpText